<template>
	<div class="menu-icon" :class="{ 'hidden-lg': !isMobile }">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			version="1.1"
			x="0px"
			y="0px"
			:viewBox="viewBox"
			xml:space="preserve"
		>
			<g v-if="isMobile">
				<g id="cross">
					<g>
						<polygon
							points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011 "
							fill="#00a2bc"
						/>
					</g>
				</g>
			</g>
			<g v-else>
				<rect y="36" width="302" height="30" fill="#00a2bc" />
				<rect y="236" width="302" height="30" fill="#00a2bc" />
				<rect y="136" width="302" height="30" fill="#00a2bc" />
			</g>
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
			<g />
		</svg>
	</div>
</template>

<script>
export default {
	name: 'HeaderMenuIcon',
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		viewBox() {
			return this.isMobile ? '0 0 612 612' : '0 0 302 302'
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/header/HeaderMenuIcon.vue